(function () {
  'use strict';
  const C = window.PampasB2BCore;
  if (!C) return;
  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    document.body.classList.add('pmb-page');
    // Flashy's shadow-root !important styles can override page CSS and leave a
    // top-layer popover/backdrop intercepting catalog clicks. Suppress that
    // marketing surface only while this dedicated B2B section is present.
    function dismissMarketingPopup(node) {
      if (node.nodeType !== 1 || !node.matches('flashy-popup')) return;
      try { if (node.matches(':popover-open')) node.hidePopover(); } catch (_) { /* Older browsers. */ }
      node.remove();
    }
    document.querySelectorAll('flashy-popup').forEach(dismissMarketingPopup);
    const popupObserver = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(dismissMarketingPopup)));
    popupObserver.observe(document.body, { childList: true });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) popupObserver.disconnect();
    });
    const $ = selector => root.querySelector(selector);
    const $$ = selector => Array.from(root.querySelectorAll(selector));
    const config = JSON.parse($('[data-config]').textContent);
    const leadCapture = window.PampasB2BLeads && window.PampasB2BLeads.create({ endpoint: 'https://pampas-dashboard-live.vercel.app/api/b2b-leads' });
    let emailCapturePending = false, emailCapturePass = false;
    const t = key => config.labels[key] || key;
    const mobileLayout = window.matchMedia('(max-width: 749px)');
    function updateMobileLayout() {
      $$('[data-mobile-disclosure]').forEach(el => { el.open = !mobileLayout.matches; });
    }
    updateMobileLayout();
    mobileLayout.addEventListener('change', updateMobileLayout);
    $('[data-filter-toggle]').addEventListener('click', event => {
      const button = event.currentTarget;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      $('[data-advanced-filters]').dataset.expanded = String(expanded);
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) mobileLayout.removeEventListener('change', updateMobileLayout);
    });
    if (config.previewTheme && typeof ResizeObserver === 'function') {
      let previewResize;
      const previewWatch = new MutationObserver(connectPreviewBar);
      function connectPreviewBar() {
        const bar = document.getElementById('PBarNextFrameWrapper');
        if (!bar) return;
        previewWatch.disconnect();
        const measure = () => {
          const offset = Math.min(120, Math.max(0, bar.getBoundingClientRect().height)) + 'px';
          root.style.setProperty('--pmb-preview-offset', offset);
          document.body.style.setProperty('--pmb-preview-offset', offset);
        };
        previewResize = new ResizeObserver(measure); previewResize.observe(bar); measure();
      }
      previewWatch.observe(document.body, { childList: true }); connectPreviewBar();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) { previewWatch.disconnect(); if (previewResize) previewResize.disconnect(); document.body.style.removeProperty('--pmb-preview-offset'); }
      });
    }
    const logoToggle = $('[data-logo-toggle]');
    const logoStrip = $('[data-logo-strip]');
    if (logoToggle && logoStrip) {
      logoToggle.hidden = false;
      logoToggle.addEventListener('click', () => {
        const paused = logoStrip.dataset.paused !== 'true';
        logoStrip.dataset.paused = String(paused);
        logoToggle.textContent = paused ? 'הפעלת התנועה' : 'עצירת התנועה';
        logoToggle.setAttribute('aria-label', paused ? 'הפעלת תנועת לוגואי הלקוחות' : 'עצירת תנועת לוגואי הלקוחות');
      });
    }
    const grid = $('[data-grid]');
    const detail = $('[data-detail-dialog]');
    const selection = $('[data-selection-dialog]');
    const key = 'pampas-b2b-selection-v1';
    let products = [], items = [], pageSize = 24, detailId = '', returnFocus = null, mode = 'selection', statusTimer;
    const galleryIndexes = new Map();
    const filter = { search: '', category: '', budget: '', sort: 'default', branding: false };
    function announce(text) {
      clearTimeout(statusTimer);
      $('[data-status]').textContent = text;
      statusTimer = setTimeout(() => { $('[data-status]').textContent = ''; }, 4000);
    }
    function ingest(container) {
      container.querySelectorAll('[data-product-id]').forEach(card => {
        const p = JSON.parse(card.querySelector('[data-product-json]').textContent);
        p.description = p.description.replace(/&(amp|quot|apos|lt|gt|nbsp);|&#(\d+);|&#x([0-9a-f]+);/gi, (entity, named, decimal, hex) => {
          if (named) return ({ amp: '&', quot: '"', apos: "'", lt: '<', gt: '>', nbsp: ' ' })[named.toLowerCase()];
          const code = decimal ? Number(decimal) : parseInt(hex, 16);
          return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : entity;
        });
        if (products.some(x => x.id === p.id)) return;
        p.index = Number(card.dataset.productOrder); p.card = card;
        p.starting = config.currency === 'ILS' ? C.price(p, config) : null;
        products.push(p);
        if (container !== grid) grid.appendChild(card);
        if (p.starting) {
          card.querySelector('[data-card-price]').textContent = p.starting.label;

        }
        card.querySelector('[data-add]').hidden = false;
      });
    }
    function save() {
      try { localStorage.setItem(key, C.serialize(items, Date.now())); }
      catch (_) { announce('הבחירה זמינה בביקור הזה. הדפדפן לא מאפשר לשמור אותה לביקור הבא.'); }
    }
    function renderCatalog() {
      const matches = C.selectProducts(products, filter);
      products.forEach(p => { p.card.hidden = true; });
      matches.slice(0, pageSize).forEach(p => { grid.appendChild(p.card); p.card.hidden = false; });
      $('[data-result]').textContent = matches.length + ' מתנות לבחירה' + (pageSize < matches.length ? ' · מוצגות ' + pageSize : '');
      $('[data-empty]').hidden = matches.length !== 0;
      $('[data-more]').hidden = pageSize >= matches.length;
      const active = filter.search || filter.category || filter.budget || filter.branding || filter.sort !== 'default';
      $('[data-reset]').disabled = !active;
      const filterCount = [filter.search, filter.category, filter.budget, filter.branding, filter.sort !== 'default'].filter(Boolean).length;
      $('[data-filter-count]').textContent = filterCount ? '(' + filterCount + ')' : '';
      $$('[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === filter.category)));
    }
    function variantOptions(p, selected) {
      return '<option value="">אבחר בהמשך</option>' + p.variants.filter(v => v.title !== 'Default Title').map(v => '<option value="' + esc(v.id) + '"' + (String(selected) === String(v.id) ? ' selected' : '') + '>' + esc(v.title) + (!v.available ? ' · זמינות בבדיקה' : '') + '</option>').join('');
    }
    function sync() {
      products.forEach(p => {
        const selected = items.some(i => i.id === p.id), button = p.card.querySelector('[data-add]');
        button.textContent = selected ? 'נוסף לבחירות שלי ✓' : 'להוסיף לבחירות שלי';
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-label', (selected ? 'הסרת ' : 'הוספת ') + p.title + (selected ? ' מהבחירה' : ' לבחירה'));
        p.card.classList.toggle('is-selected', selected);
      });
      $$('[data-selection-count]').forEach(el => { el.textContent = String(items.length); });
      $('[data-tray-note]').textContent = items.length ? items.length + ' מתנות מחכות ברשימה שלכם' : 'כל המתנות שאהבתם, במקום אחד';
      $('[data-tray-images]').innerHTML = items.slice(0, 5).map(i => products.find(p => p.id === i.id)).filter(p => p && p.image).map(p => '<img src="' + esc(p.image) + '" alt="" width="48" height="48">').join('');
      if (detail.open) {
        const button = detail.querySelector('[data-detail-add]');
        if (button) button.textContent = items.some(i => i.id === detailId) ? 'עדכון הבחירה' : 'להוסיף לבחירות שלי';
      }
    }
    function toggleItem(id) {
      const p = products.find(p => p.id === id);
      if (!p) return;
      if (items.some(i => i.id === id)) {
        items = items.filter(i => i.id !== id); announce(p.title + ' הוסר מהבחירה');
      } else {
        items.push({ id, variant: '', quantity: null }); announce(p.title + ' נוסף לבחירה');
      }
      save(); sync();
    }
    function showDialog(dialog) {
      returnFocus = document.activeElement;
      dialog.showModal(); document.body.classList.add('pmb-dialog-open');
    }
    [detail, selection].forEach(dialog => {
      dialog.addEventListener('close', () => {
        document.body.classList.remove('pmb-dialog-open');
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target.closest('[data-close]')) dialog.close();
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      });
    });
    function imageUrl(src, width) {
      try { const url = new URL(src, location.origin); if (url.protocol !== 'https:') return ''; url.searchParams.set('width', String(width)); return url.href; }
      catch (_) { return ''; }
    }
    const gallerySelections = {
      '9446433063135': [0,1,3,7,11,13,14],
      '9446401474783': [0,1,2,3,4,5,8],
      '9446398296287': [0,1,2,3,5,6,8],
      '9446401310943': [0,1,2,5,7,11,14],
      '9446441025759': [0,1,2,4,6,8,11],
      '9446400819423': [0,1,2,3,4,6,12],
      '9446437585119': [0,1,2,3,6,7,12],
      '9446468518111': [0,1,2,3,4,6,7],
      '9446402162911': [0,1,2,4,6,7,9]
    };
    function galleryImages(p) {
      const images = [...new Set((p.images && p.images.length ? p.images : [p.image]).filter(Boolean))];
      if (images.length <= 7) return images;
      const indexes = gallerySelections[p.id] || Array.from({ length: 7 }, (_, i) => Math.round(i * (images.length - 1) / 6));
      return indexes.map(i => images[i]).filter(Boolean);
    }
    function changeCardImage(card, step) {
      const p = products.find(p => p.id === card.dataset.productId), images = p && galleryImages(p);
      if (!images || !images.length) return;
      const index = ((galleryIndexes.get(p.id) || 0) + step + images.length) % images.length;
      galleryIndexes.set(p.id, index);
      const image = card.querySelector('.pmb-card-image img');
      image.removeAttribute('srcset'); image.src = imageUrl(images[index], 720);
      card.querySelector('[data-card-position]').textContent = (index + 1) + ' / ' + images.length;
    }
    function changeDetailImage(index) {
      const p = products.find(p => p.id === detailId), images = galleryImages(p);
      if (!images.length) return;
      const position = (index + images.length) % images.length;
      detail.dataset.imageIndex = String(position);
      $('[data-detail-image]').src = imageUrl(images[position], 900);
      $('[data-detail-position]').textContent = (position + 1) + ' / ' + images.length;
      detail.querySelectorAll('[data-gallery-index]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.galleryIndex) === position)));
    }
    function description(p) {
      if (p.id === '9446433063135') return '<ul><li>נר לני לבן, בגובה כ־8 ס״מ, עם מדבקת הקדשה אישית ומלל לבחירתכם.</li><li>אריזת צלופן.</li><li>פפיון סאטן.</li><li>פמפס יבש לבחירה.</li></ul><p>באיסוף עצמי מגיע ארוז. במשלוח מצורפים חומרי האריזה והנחיות לסידור המתנה.</p>';
      const doc = new DOMParser().parseFromString(p.descriptionHtml || '', 'text/html');
      doc.querySelectorAll('script,style,iframe,form').forEach(n => n.remove());
      doc.querySelectorAll('br').forEach(n => n.replaceWith('\n'));
      const blocks = Array.from(doc.querySelectorAll('p,li,h2,h3,h4')).filter(n => !n.querySelector('p,li,h2,h3,h4'));
      let lines = blocks.length ? blocks.map(n => n.textContent.trim()) : p.description.split(/\n+/);
      lines = lines.flatMap(line => line.split(/\s+&\s+|\n+/)).map(line => line.trim().replace(/^[*•\-]+\s*/, '')).filter(Boolean);
      return '<ul>' + [...new Set(lines)].map(line => '<li>' + esc(line) + '</li>').join('') + '</ul>';
    }
    function stickerInfo(p) {
      const included = ['9446433063135','9446401474783','9446398296287','9446401310943','9446398820575','9446394331359','9446401147103','9446400819423','9446400164063','9446397346015','9446420971743','9446409699551','9446396854495','9446396362975','9446394953951','9446392594655','9446389383391','9446402162911','9446401867999','9446400721119','9446400393439','9446400360671','9446399803615','9446400491743','9446391611615','9446395248863','9446396526815','9551974990047'].includes(p.id);
      const optional = ['9446468518111','9446401999071','9446441025759','9446395511007'].includes(p.id);
      if (!included && !optional) return '';
      return '<details class="pmb-important"><summary>חשוב לדעת על המדבקה האישית <span aria-hidden="true">⌄</span></summary><ul><li>לפני הדפסת המדבקה תקבלו סקיצה לאישור סופי.</li><li>ניתן לעצב את המדבקה בהתאמה אישית, כולל תמונה או עיצוב מוכן.</li><li>' + (included ? 'מחיר המוצר כולל עיצוב אחד של מדבקה. כל עיצוב נוסף בתוספת 4 ₪.' : 'הוספת מדבקה למוצר זה בתשלום נוסף, שיפורט בהצעה. כל עיצוב נוסף בתוספת 4 ₪.') + '</li><li>צורת המדבקה וצבעה — לבן או שקוף — בהתאם למלאי.</li><li>ניתן לבקש שקית נייר לכל מתנה; המחיר יאושר בהצעה.</li></ul></details>';
    }
    function renderPriceTable(p, variantId) {
      const rows = config.currency === 'ILS' ? C.tiers(p, config, variantId) : [];
      const host = $('[data-price-table]');
      if (!rows.length) { host.innerHTML = '<p class="pmb-quote-note">מחיר בהצעה אישית בהתאם לכמות ולאפשרות שתבחרו.</p>'; return; }
      const ids = [...new Set(rows.map(r => r.variantId))];
      host.innerHTML = '<h3>מחיר לפי כמות</h3>' + ids.map(id => {
        const variantRows = rows.filter(r => r.variantId === id), first = variantRows[0];
        return '<table class="pmb-price-table"><caption>' + (first.variantTitle === 'Default Title' ? 'מחיר ליחידה מאותו מוצר' : esc(first.variantTitle)) + (first.packUnits > 1 ? ' · ' + first.packUnits + ' מתנות בחבילה' : '') + '</caption><thead><tr><th scope="col">' + (first.packUnits > 1 ? 'כמות חבילות / מתנות' : 'כמות מתנות') + '</th><th scope="col">' + esc(t('unit_price')) + '</th></tr></thead><tbody>' + (first.baseCents != null ? '<tr class="pmb-price-base"><th scope="row">' + esc(t('before_quantity_discount')) + '</th><td><bdi>' + esc(C.money(first.baseCents)) + '</bdi>' + (first.packUnits > 1 ? '<br><small>' + esc(C.money(first.basePackCents)) + ' לחבילה</small>' : '') + '</td></tr>' : '') + variantRows.map(r => '<tr><th scope="row"><bdi>' + r.from + (r.to ? '–' + r.to : '+') + '</bdi>' + (r.packUnits > 1 ? ' חבילות<br><small>(' + r.from * r.packUnits + (r.to ? '–' + r.to * r.packUnits : '+') + ' מתנות)</small>' : '') + '</th><td><bdi>' + esc(C.money(r.cents)) + '</bdi><span class="pmb-tier-discount">' + (r.percent > 0 ? '<bdi>' + r.percent + '%</bdi> ' + esc(t('discount_word')) : esc(t(r.quoteOnly ? 'quote_price' : 'no_quantity_discount'))) + '</span>' + (r.packUnits > 1 ? '<br><small>' + esc(C.money(r.packCents)) + ' לחבילה</small>' : '') + '</td></tr>').join('') + '</tbody></table>';
      }).join('') + '<p class="pmb-micro">המחירים בהתאם לכמות מאותו מוצר ולאפשרות המוצגת. מיתוג נוסף, אריזה מיוחדת ומשלוח יאושרו בהצעה. אין כאן חישוב מחיר להזמנה.</p>';
    }
    function openDetail(id) {
      const p = products.find(p => p.id === id);
      if (!p) return;
      detailId = id;
      const selected = items.find(i => i.id === id), images = galleryImages(p), sid = root.dataset.sectionId;
      $('[data-detail-body]').innerHTML = '<div class="pmb-detail-grid"><div><div class="pmb-detail-gallery"><img class="pmb-detail-image" data-detail-image src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="720" height="720">' + (images.length > 1 ? '<button type="button" class="pmb-gallery-prev" data-detail-step="-1" aria-label="התמונה הקודמת">›</button><button type="button" class="pmb-gallery-next" data-detail-step="1" aria-label="התמונה הבאה">‹</button>' : '') + '</div><p class="pmb-gallery-count" data-detail-position></p><div class="pmb-thumbnails">' + images.map((src, i) => '<button type="button" data-gallery-index="' + i + '" aria-label="תמונה ' + (i + 1) + '" aria-pressed="false"><img src="' + esc(imageUrl(src, 100)) + '" alt="" loading="lazy" width="60" height="60"></button>').join('') + '</div><button type="button" class="pmb-text-button" data-share>' + esc(t('product_share')) + '</button><p class="pmb-micro" data-share-status role="status"></p></div><div class="pmb-detail-copy"><h2 id="pmb-detail-title-' + esc(sid) + '">' + esc(p.title) + '</h2><p class="pmb-price">' + esc(p.starting ? p.starting.label : 'מחיר בהצעה אישית') + '</p><details class="pmb-product-description"><summary>' + esc(t('product_description')) + ' <span aria-hidden="true">⌄</span></summary>' + description(p) + '</details>' + stickerInfo(p) + (p.variants.some(v => v.title !== 'Default Title') ? '<label class="pmb-field"><span>אפשרות מועדפת</span><select data-detail-variant>' + variantOptions(p, selected && selected.variant) + '</select></label>' : '') + '<label class="pmb-field"><span>כמות מתנות — מ־20 מאותו מוצר (לא חובה)</span><input data-detail-quantity type="number" inputmode="numeric" min="20" max="999999" step="1" placeholder="טרם נקבעה" value="' + (selected && selected.quantity || '') + '"></label><div class="pmb-tier-area" data-price-table></div><button type="button" class="pmb-button" data-detail-add>' + (selected ? 'עדכון הבחירה' : 'להוסיף לבחירות שלי') + '</button></div></div>';
      renderPriceTable(p, selected && selected.variant);
      detail.querySelectorAll('details').forEach(disclosure => { disclosure.open = false; });
      changeDetailImage(0); showDialog(detail);
      detail.scrollTop = 0;
    }
    async function shareGift() {
      const p = products.find(p => p.id === detailId);
      const url = new URL(location.href); url.search = ''; url.hash = 'gift=' + p.id;
      if (config.previewTheme) url.searchParams.set('preview_theme_id', config.previewTheme);
      try {
        if (navigator.share) { await navigator.share({ title: p.title, text: p.title + ' | פמפס לאירועים ועסקים', url: url.href }); return; }
        await navigator.clipboard.writeText(url.href);
        $('[data-share-status]').textContent = 'הקישור למוצר הועתק. אפשר לשתף אותו בוואטסאפ.';
      } catch (error) {
        if (error.name === 'AbortError') return;
        $('[data-share-status]').innerHTML = '<label class="pmb-field"><span>אפשר להעתיק את הקישור ולשתף</span><input readonly value="' + esc(url.href) + '"></label>';
      }
    }
    function renderSelection() {
      $('[data-selection-items]').innerHTML = items.length ? items.map(item => {
        const p = products.find(p => p.id === item.id);
        return '<article class="pmb-selection-item" data-item="' + esc(item.id) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="80" height="80"><div class="pmb-selection-copy"><h3>' + esc(p.title) + '</h3><p class="pmb-micro">' + esc(p.starting ? p.starting.label : 'מחיר בהצעה אישית') + (p.starting ? '<br><span class="pmb-quantity-price-note">' + esc(t('quantity_price_note')) + '</span>' : '') + '</p><div class="pmb-item-fields">' + (p.variants.some(v => v.title !== 'Default Title') ? '<label class="pmb-field"><span>אפשרות מועדפת</span><select data-item-variant>' + variantOptions(p, item.variant) + '</select></label>' : '') + '<label class="pmb-field"><span>כמות מתנות — מ־20 (לא חובה)</span><input data-item-quantity type="number" inputmode="numeric" min="20" max="999999" step="1" placeholder="טרם נקבעה" value="' + (item.quantity || '') + '"></label></div><button type="button" class="pmb-text-button" data-remove="' + esc(item.id) + '" aria-label="הסרת ' + esc(p.title) + ' מהבחירה">הסרה מהבחירה</button></div></article>';
      }).join('') : '<div class="pmb-empty"><h3>אפשר לפנות גם בלי לבחור מתנות</h3><p>' + esc(t('catalog_intro')) + '</p><button type="button" class="pmb-text-button" data-close>או לחזור לבחירת מתנות</button></div>';
      $('[data-message-area]').hidden = false;
      updateMessage();
    }
    function setRequestStep(step, focus) {
      selection.dataset.step = 'contact';
      selection.dataset.mode = mode;
      $('[data-selection-panel]').hidden = mode === 'budget';
      $('[data-email-panel]').hidden = false;
      $('[data-email-footer]').hidden = false;
      $('[data-message-area]').hidden = false;
      const title = $('[data-selection-dialog] h2');
      title.textContent = mode === 'budget' ? t('budget_title') : t('email_title');
      $('[data-request-subtitle]').textContent = t('email_subtitle');
      $('[data-request-scroll]').scrollTop = 0;
      updateMessage(); updateEmail();
      if (focus) { title.tabIndex = -1; title.focus({ preventScroll: true }); }
    }
    function readBrief() {
      const values = Object.fromEntries(new FormData($('[data-email-form]')).entries());
      return C.inquiryBrief(values, mode);
    }
    async function captureInquiry(channel) {
      if (!leadCapture) return Promise.resolve(false);
      try {
      const gifts = items.map(item => {
        const p = products.find(product => product.id === item.id);
        const v = p.variants.find(variant => String(variant.id) === String(item.variant));
        return { id: String(p.id), title: p.title, path: decodeURI(new URL(p.url, location.origin).pathname),
          variantId: v ? String(v.id) : '', variant: v && v.title !== 'Default Title' ? v.title : '', quantity: item.quantity };
      });
      const payload = { channel, brief: readBrief(), items: gifts, preview: Boolean(config.previewTheme) };
      return leadCapture.capture(payload);
      } catch (_) { return false; }
    }
    function updateEmail() {
      const list = $('[data-email-items]');
      if (!list) return;
      list.closest('.pmb-email-selection').hidden = mode !== 'budget';
      list.innerHTML = items.length ? items.map(item => {
        const p = products.find(p => p.id === item.id);
        const v = p.variants.find(v => String(v.id) === String(item.variant));
        return '<li><img src="' + esc(p.image) + '" alt="" width="44" height="44"><div><strong>' + esc(p.title) + '</strong><span>' + esc(v && v.title !== 'Default Title' ? v.title : 'אפשרות: אבחר בהמשך') + ' · כמות: ' + (item.quantity || 'טרם נקבעה') + '</span></div></li>';
      }).join('') : '<li>' + esc(t('email_empty')) + '</li>';
      $('[data-email-body]').value = C.message(items, products, readBrief(), location.origin).replace(/\*/g, '');
    }
    function validItems() {
      const fields = $$('[data-item-quantity]');
      for (const field of fields) if (!field.validity.valid) {
        mode = 'selection'; setRequestStep('selection', false); field.reportValidity(); return false;
      }
      return true;
    }
    function openRequest(nextMode) {
      mode = nextMode; renderSelection();
      setRequestStep(mode === 'budget' ? 'brief' : 'selection', false);
      showDialog(selection);
    }
    function updateMessage() {
      if (!$('[data-inquiry-email]')) return;
      const text = C.message(items, products, readBrief(), location.origin, true);
      if ($('[data-message]').value !== text) $('[data-copy-status]').textContent = '';
      $('[data-message]').value = text;
      const wa = C.whatsapp(config.phone, text);
      const link = $('[data-whatsapp]');
      link.setAttribute('href', '#');
      link.textContent = t('whatsapp_action');
      if (wa && $('[data-email-form]').checkValidity() && $$('[data-item-quantity]').every(field => field.validity.valid)) link.href = wa.href;
      link.setAttribute('aria-disabled', String(!wa));
      updateEmail();
      $('[data-channel-note]').textContent = t('mail_direct_note');
    }
    function clearEmailPrompt() {
      $('[data-email-needed]').hidden = true;
      $('[data-inquiry-email]').removeAttribute('aria-invalid');
    }
    function validSelection() {
      if (!validItems()) return false;
      return $('[data-email-form]').reportValidity();
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('button,a'); if (!button) return;
      if (button.matches('[data-add]')) { toggleItem(button.dataset.add); return; }
      if (button.matches('[data-detail-link]')) {
        event.preventDefault(); openDetail(button.closest('[data-product-id]').dataset.productId); return;
      }
      if (button.matches('[data-category]')) { filter.category = button.dataset.category; pageSize = 24; renderCatalog(); }
      if (button.matches('[data-reset]')) {
        Object.assign(filter, { search: '', category: '', budget: '', sort: 'default', branding: false });
        $('[data-search]').value = ''; $('[data-budget]').value = ''; $('[data-sort]').value = 'default';
        pageSize = 24; renderCatalog(); $('[data-search]').focus({ preventScroll: true });
      }
      if (button.matches('[data-more]')) { pageSize += 24; renderCatalog(); }
      if (button.matches('[data-open-selection],[data-open-budget]')) openRequest(button.matches('[data-open-budget]') ? 'budget' : 'selection');
      if (button.matches('[data-mode]')) { if (!validItems()) return; mode = button.dataset.mode; setRequestStep('brief', true); }
      if (button.matches('[data-edit-selection],[data-request-step="selection"],[data-request-back]')) {
        if (button.matches('[data-request-back]') && !items.length) selection.close();
        else { mode = 'selection'; setRequestStep('selection', true); }
      }
      if (button.matches('[data-card-step]')) changeCardImage(button.closest('[data-product-id]'), Number(button.dataset.cardStep));
      if (button.matches('[data-detail-step]')) changeDetailImage(Number(detail.dataset.imageIndex || 0) + Number(button.dataset.detailStep));
      if (button.matches('[data-gallery-index]')) changeDetailImage(Number(button.dataset.galleryIndex));
      if (button.matches('[data-share]')) shareGift();
      if (button.matches('[data-remove]')) {
        const oldIndex = items.findIndex(i => i.id === button.dataset.remove);
        items = items.filter(i => i.id !== button.dataset.remove); save(); sync(); renderSelection();
        $('[data-request-subtitle]').textContent = items.length + ' מתנות שאהבתם · אפשר לערוך כאן';
        const next = selection.querySelectorAll('[data-remove]')[Math.min(oldIndex, items.length - 1)] || selection.querySelector('[data-close]');
        next.focus();
      }
      if (button.matches('[data-detail-add]')) {
        const qty = $('[data-detail-quantity]'); if (!qty.reportValidity()) return;
        const next = { id: detailId, variant: $('[data-detail-variant]') ? $('[data-detail-variant]').value : '', quantity: C.quantity(qty.value) };
        const index = items.findIndex(i => i.id === detailId);
        if (index >= 0) items[index] = next; else items.push(next);
        save(); sync(); detail.close(); announce('המתנה נשמרה במגש הבחירה שלכם');
      }
      if (button.matches('[data-whatsapp]')) {
        if (!validSelection() || button.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
        updateMessage();
        captureInquiry('whatsapp');
      }
      if (button.matches('[data-new-inquiry]')) {
        if (leadCapture) leadCapture.reset();
        const form = $('[data-email-form]');
        form.querySelectorAll('input:not([type=hidden]),textarea:not([hidden])').forEach(field => { field.value = ''; });
        $$('[data-email-success],[data-email-errors]').forEach(el => { el.hidden = true; });
        clearEmailPrompt();
        updateMessage();
        form.querySelector('input:not([type=hidden])').focus();
      }
      if (button.matches('[data-copy]')) copyMessage();
    });
    async function copyMessage(direct) {
      if (!validSelection()) return;
      const field = $('[data-message]');
      const status = $('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(field.value);
        status.textContent = 'הבקשה הועתקה. אפשר להדביק אותה בשיחת הוואטסאפ.';
      } catch (_) {
        field.closest('details').open = true; field.focus(); field.select();
        status.textContent = 'ההעתקה האוטומטית לא זמינה. הטקסט מסומן — העתיקו אותו ידנית.';
      }
    }
    root.addEventListener('input', event => {
      if (event.target.matches('[data-search]')) { filter.search = event.target.value; pageSize = 24; renderCatalog(); }
      if (event.target.matches('[data-item-quantity]')) {
        const item = items.find(i => i.id === event.target.closest('[data-item]').dataset.item);
        if (item && event.target.validity.valid) { item.quantity = C.quantity(event.target.value); save(); updateMessage(); }
      }
      if (event.target.matches('[data-inquiry-email]')) clearEmailPrompt();
      if (event.target.closest('[data-email-form]')) updateMessage();
    });
    root.addEventListener('change', event => {
      if (event.target.matches('[data-detail-variant]')) renderPriceTable(products.find(p => p.id === detailId), event.target.value);
      if (event.target.matches('[data-budget]')) filter.budget = event.target.value;
      if (event.target.matches('[data-sort]')) filter.sort = event.target.value;
      if (event.target.matches('[data-branding-filter]')) filter.branding = event.target.checked;
      if (event.target.closest('[data-controls]')) { pageSize = 24; renderCatalog(); }
      if (event.target.matches('[data-item-variant]')) {
        const item = items.find(i => i.id === event.target.closest('[data-item]').dataset.item);
        if (item) { item.variant = event.target.value; save(); updateMessage(); }
      }
      if (event.target.closest('[data-email-form]')) updateMessage();
    });
    $('[data-email-form]').addEventListener('submit', event => {
      if (!validSelection()) { event.preventDefault(); return; }
      updateEmail();
      if (!$('[data-inquiry-email]').value.trim()) {
        event.preventDefault();
        $('[data-email-needed]').hidden = false;
        $('[data-inquiry-email]').setAttribute('aria-invalid', 'true');
        $('[data-inquiry-email]').focus();
        return;
      }
      if (!event.currentTarget.reportValidity()) { event.preventDefault(); return; }
      if (emailCapturePass) { emailCapturePass = false; return; }
      if (!leadCapture) return;
      event.preventDefault();
      if (emailCapturePending) return;
      emailCapturePending = true;
      const form = event.currentTarget, submitter = event.submitter;
      captureInquiry('email').finally(() => {
        emailCapturePending = false;
        emailCapturePass = true;
        try { form.requestSubmit(submitter || undefined); }
        finally { emailCapturePass = false; }
      });
    });
    async function start() {
      ingest(grid);
      const pager = $('[data-pagination]');
      const pages = Number(pager && pager.dataset.pages || 1), current = Number(pager && pager.dataset.page || 1);
      if (pages > 1) {
        $('[data-result]').textContent = 'טוענים את כל המתנות…';
        try {
          for (let page = 1; page <= pages; page++) {
            if (page === current) continue;
            const url = new URL(location.href); url.hash = '';
            url.searchParams.set('section_id', root.dataset.sectionId);
            url.searchParams.set(pager.dataset.pageParam || 'page', String(page));
            const response = await fetch(url.href, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Incomplete catalog');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            if (!doc.querySelector('[data-grid]')) throw new Error('Missing section');
            ingest(doc);
          }
        } catch (_) {
          $('[data-load-error]').hidden = false;
          $('[data-load-error]').textContent = 'חלק מהקטלוג לא נטען. הסינון מתייחס למתנות שנטענו בלבד. רעננו את העמוד כדי לנסות שוב.';
        }
      }
      products.sort((a, b) => a.index - b.index);
      try { items = C.restore(localStorage.getItem(key), products, Date.now()); } catch (_) { items = []; }
      $('[data-controls]').hidden = false; $('[data-tray]').hidden = false;
      renderCatalog(); sync();
      const linked = /^#gift=(\d+)$/.exec(location.hash); if (linked) openDetail(linked[1]);
      if ($('[data-email-success]')) {
        const cleanUrl = C.clearContactResult(location.href, $('[data-email-form]').id);
        if (cleanUrl !== location.href) history.replaceState(history.state, '', cleanUrl);
      }
      if ($('[data-email-success]') || $('[data-email-errors]')) {
        mode = 'selection'; renderSelection(); setRequestStep('email', false); showDialog(selection);
        ($('[data-email-success]') || $('[data-email-errors]')).focus();
      }
    }
    start().catch(() => {
      $('[data-load-error]').hidden = false;
      $('[data-load-error]').textContent = 'הבחירה האינטראקטיבית לא נטענה. רעננו ונסו שוב או פנו אלינו בטלפון 050-5455424.';
    });
  }
  document.querySelectorAll('[data-pmb]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pmb]').forEach(init));
})();
